module.exports = __webpack_public_path__ + "6658c7349da28374de4f481f80013a30.png";